import { ServiceTypeKey, SettlementStatisticsRes } from '@/services/settlement/settlementManagement/types'

export const SETTLEMENT_CLOSED_STATUS_MAP: { [key in SettlementStatisticsRes['settlementClosedStatus']]: string } = {
  PENDING: '마감예정',
  COMPLETED: '마감완료',
}

// 정산 상세는 탭마다 컬럼이 달라 개인 컬럼 배치 키를 탭별로 나눈다
export const SETTLEMENT_DETAIL_GRID_KEY_BY_TAB: Record<ServiceTypeKey, string> = {
  ALL: 'BL03_ALL',
  INVENTORY: 'BL03_INV',
  INBOUND: 'BL03_IN',
  OUTBOUND_TO_CUSTOMER: 'BL03_OUTC',
  OUTBOUND_TO_STORE: 'BL03_OUTS',
  RETURN_INBOUND: 'BL03_RET',
  MEASUREMENT: 'BL03_MSR',
  ETC_ADJUSTMENT: 'BL03_ETC',
}

// 엑셀 다운로드 감사로그 — 상세(/bl/bl03/:id)는 경로 끝이 화면코드가 아니라 MENU_CD 를 넘긴다
export const SETTLEMENT_DETAIL_EXPORT_AUDIT = { menuCode: 'BL03' }
// API_NM BL03_PROMOTION_LIST_EXPORT
export const PROMOTION_EXPORT_AUDIT = { ...SETTLEMENT_DETAIL_EXPORT_AUDIT, tab: 'PROMOTION' }
